import React from 'react';
import { Card, CardBody, Progress, Button, Badge } from 'reactstrap';
import { Download } from 'react-feather';

import ResultRow from './ResultRow.component';

function downloadJson(results) {
  const blob = new Blob([JSON.stringify(results, null, 2)], { type: 'application/json' });
  const url = URL.createObjectURL(blob);
  const a = document.createElement('a');
  a.href = url;
  a.download = 'search_scrape_results.json';
  a.click();
  URL.revokeObjectURL(url);
}

// Renders run progress (for async batches) + the per-row results.
export default function ResultsView({ results, progress }) {
  const hasResults = results && results.length > 0;
  const showProgress = progress && progress.total > 0 && progress.status !== 'finished' && progress.status !== 'failed';

  if (!hasResults && !showProgress) return null;

  const successCount = (results || []).filter((r) => r.status === 'success').length;
  const totalUrls = (results || []).reduce((sum, r) => sum + (r.url_count || 0), 0);

  return (
    <Card>
      <CardBody>
        <div className="d-flex justify-content-between align-items-center mb-3">
          <h5 className="mb-0">Results</h5>
          {hasResults && (
            <div>
              <Badge color="success" className="me-2">{successCount} ok</Badge>
              <Badge color="light" className="text-dark me-3">{totalUrls} URLs scraped</Badge>
              <Button color="outline-secondary" size="sm" onClick={() => downloadJson(results)}>
                <Download size={14} className="me-1" />Export JSON
              </Button>
            </div>
          )}
        </div>

        {showProgress && (
          <div className="mb-3">
            <div className="d-flex justify-content-between small mb-1">
              <span className="text-uppercase fw-bold">{progress.status}</span>
              <span>{progress.completed} / {progress.total} rows</span>
            </div>
            <Progress
              animated
              value={progress.total ? (progress.completed / progress.total) * 100 : 0}
            />
          </div>
        )}

        {(results || []).map((row, i) => (
          <ResultRow row={row} index={i} key={i} />
        ))}
      </CardBody>
    </Card>
  );
}
